export default "/images/vendor/flag-icon-css/flags/1x1/yt.svg?bf9663aea16580e485d0b525dfaa73f1";